module.exports = __webpack_public_path__ + "img/techshelter.84481158.png";